const nutrientRequirements = {
  "Protein (g)": {
    "Adult Neutered / Low Active": 2.62,
    "Adult Active": 2.62,
    "Puppy < 4 months": 9.75,
    "Puppy > 4 months": 5.63,
    "Weight Loss": 2.62,
    "Senior": 2.62
  },
  "Fat (g)": {
    "Adult Neutered / Low Active": 1.3,
    "Adult Active": 1.3,
    "Puppy < 4 months": 3.3,
    "Puppy > 4 months": 2.2,
    "Weight Loss": 1.3,
    "Senior": 1.3
  },
  "Calcium (mg)": {
    "Adult Neutered / Low Active": 30.0,
    "Adult Active": 30.0,
    "Puppy < 4 months": 320.0,
    "Puppy > 4 months": 130.0,
    "Weight Loss": 30.0,
    "Senior": 30.0
  },
  "Phosphorus (mg)": {
    "Adult Neutered / Low Active": 26.0,
    "Adult Active": 26.0,
    "Puppy < 4 months": 270.0,
    "Puppy > 4 months": 105.0,
    "Weight Loss": 26.0,
    "Senior": 26.0
  },
  "Magnesium (mg)": {
    "Adult Neutered / Low Active": 150.0,
    "Adult Active": 150.0,
    "Puppy < 4 months": 150.0,
    "Puppy > 4 months": 150.0,
    "Weight Loss": 150.0,
    "Senior": 150.0
  },
  "Sodium (mg)": {
    "Adult Neutered / Low Active": 13.0,
    "Adult Active": 13.0,
    "Puppy < 4 months": 25.0,
    "Puppy > 4 months": 20.0,
    "Weight Loss": 13.0,
    "Senior": 13.0
  },
  "Potassium (mg)": {
    "Adult Neutered / Low Active": 50.0,
    "Adult Active": 50.0,
    "Puppy < 4 months": 85.0,
    "Puppy > 4 months": 65.0,
    "Weight Loss": 50.0,
    "Senior": 50.0
  },
  "Zinc (mg)": {
    "Adult Neutered / Low Active": 1.1,
    "Adult Active": 1.1,
    "Puppy < 4 months": 2.0,
    "Puppy > 4 months": 1.6,
    "Weight Loss": 1.1,
    "Senior": 1.1
  },
  "Iron (mg)": {
    "Adult Neutered / Low Active": 0.5,
    "Adult Active": 0.5,
    "Puppy < 4 months": 1.5,
    "Puppy > 4 months": 0.9,
    "Weight Loss": 0.5,
    "Senior": 0.5
  },
  "Copper (mg)": {
    "Adult Neutered / Low Active": 0.1,
    "Adult Active": 0.1,
    "Puppy < 4 months": 0.2,
    "Puppy > 4 months": 0.15,
    "Weight Loss": 0.1,
    "Senior": 0.1
  },
  "Manganese (mg)": {
    "Adult Neutered / Low Active": 0.12,
    "Adult Active": 0.12,
    "Puppy < 4 months": 0.25,
    "Puppy > 4 months": 0.18,
    "Weight Loss": 0.12,
    "Senior": 0.12
  },
  "Selenium (micro-g)": {
    "Adult Neutered / Low Active": 5.0,
    "Adult Active": 5.0,
    "Puppy < 4 months": 10.0,
    "Puppy > 4 months": 7.0,
    "Weight Loss": 5.0,
    "Senior": 5.0
  },
  "Vitamin A (IU)": {
    "Adult Neutered / Low Active": 379.0,
    "Adult Active": 379.0,
    "Puppy < 4 months": 1260.0,
    "Puppy > 4 months": 1000.0,
    "Weight Loss": 379.0,
    "Senior": 379.0
  },
  "Vitamin D (IU)": {
    "Adult Neutered / Low Active": 3.4,
    "Adult Active": 3.4,
    "Puppy < 4 months": 9.0,
    "Puppy > 4 months": 7.5,
    "Weight Loss": 3.4,
    "Senior": 3.4
  },
  "Vitamin E (mg)": {
    "Adult Neutered / Low Active": 0.6,
    "Adult Active": 0.6,
    "Puppy < 4 months": 2.0,
    "Puppy > 4 months": 1.5,
    "Weight Loss": 0.6,
    "Senior": 0.6
  },
  "Thiamine (B1) (mg)": {
    "Adult Neutered / Low Active": 0.06,
    "Adult Active": 0.06,
    "Puppy < 4 months": 0.16,
    "Puppy > 4 months": 0.12,
    "Weight Loss": 0.06,
    "Senior": 0.06
  },
  "Riboflavin (B2) (mg)": {
    "Adult Neutered / Low Active": 0.1,
    "Adult Active": 0.1,
    "Puppy < 4 months": 0.24,
    "Puppy > 4 months": 0.2,
    "Weight Loss": 0.1,
    "Senior": 0.1
  },
  "Niacin (B3) (mg)": {
    "Adult Neutered / Low Active": 1.2,
    "Adult Active": 1.2,
    "Puppy < 4 months": 3.5,
    "Puppy > 4 months": 2.5,
    "Weight Loss": 1.2,
    "Senior": 1.2
  },
  "Pantothenic Acid (B5) (mg)": {
    "Adult Neutered / Low Active": 0.4,
    "Adult Active": 0.4,
    "Puppy < 4 months": 1.0,
    "Puppy > 4 months": 0.8,
    "Weight Loss": 0.4,
    "Senior": 0.4
  },
  "Pyridoxine (B6) (mg)": {
    "Adult Neutered / Low Active": 0.12,
    "Adult Active": 0.12,
    "Puppy < 4 months": 0.3,
    "Puppy > 4 months": 0.25,
    "Weight Loss": 0.12,
    "Senior": 0.12
  },
  "Folic Acid (B9) (mg)": {
    "Adult Neutered / Low Active": 0.018,
    "Adult Active": 0.018,
    "Puppy < 4 months": 0.05,
    "Puppy > 4 months": 0.04,
    "Weight Loss": 0.018,
    "Senior": 0.018
  },
  "Vitamin B12 (micro-g)": {
    "Adult Neutered / Low Active": 2.3,
    "Adult Active": 2.3,
    "Puppy < 4 months": 6.0,
    "Puppy > 4 months": 4.0,
    "Weight Loss": 2.3,
    "Senior": 2.3
  },
  "Linoleic Acid (g)": {
    "Adult Neutered / Low Active": 1.3,
    "Adult Active": 1.3,
    "Puppy < 4 months": 3.5,
    "Puppy > 4 months": 2.8,
    "Weight Loss": 1.3,
    "Senior": 1.3
  },
  "Alpha-Linolenic Acid (g)": {
    "Adult Neutered / Low Active": 0.08,
    "Adult Active": 0.08,
    "Puppy < 4 months": 0.2,
    "Puppy > 4 months": 0.15,
    "Weight Loss": 0.08,
    "Senior": 0.08
  },
  "EPA + DHA (g)": {
    "Adult Neutered / Low Active": 0.13,
    "Adult Active": 0.13,
    "Puppy < 4 months": 0.3,
    "Puppy > 4 months": 0.26,
    "Weight Loss": 0.13,
    "Senior": 0.13
  }
};